import { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import GridTable from "../../../Components/CommonTable/GridTable/GridTable";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
import { UsersApi } from "../../../App/api/users.api.js";
import filters from "./Filters.js";
import StoreModal from "../../../Components/Modals/StoreModal/StoreModal.jsx";

const Store = () => {
  const [gridToggle, SetGridToggle] = useState(false);
  const [toggleUsersDetails, setToggleUsersDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const debounceTimeout = useRef();

  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: {},
  });

  const { value, fetchAllData } = useFetchAll(() =>
    UsersApi.getAllVendor({
      ...pagination,
      search,
    })
  );

  // ---------------- Pagination ----------------
  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let updatedFilter = { ...prev.filter };

      if (data.filter) {
        updatedFilter = {
          ...updatedFilter,
          ...data.filter,
        };
      }

      return {
        page: data.page || prev.page,
        limit: data.limit || prev.limit,
        sortOrder: data.sortOrder || prev.sortOrder,
        filter: updatedFilter,
      };
    });
  };

  // ---------------- Search ----------------
  const handleSearch = useCallback((value) => {
    setSearch(value);
  }, []);

  const debouncedSearch = useCallback(
    (value) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        handleSearch(value);
      }, 1500);
    },
    [handleSearch]
  );

  // ---------------- Filters ----------------
  const handleFilter = (name, value) => {
    let data = {};

    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      data.filter = {
        [`orderDetails.${name}`]: value.code ?? value,
      };
    }

    handlePagination(data);
  };

  const handleClearFilter = () => {
    handlePagination({
      clearPagination: {
        page: 1,
        limit: 10,
        sortOrder: "desc",
        filter: {},
      },
    });

    setSearch("");
  };

  // Assign handlers to filters config
  filters.handleSearch = debouncedSearch;
  filters.handleFilter = handleFilter;
  filters.handleClearFilter = handleClearFilter;

  // ---------------- Fetch Data ----------------
  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  return (
    <>
      <div className="pt-5">
        <CommonLayout />
      </div>

      <div style={{ paddingBottom: "4rem" }}>
        <div style={{ paddingBottom: "2rem" }}>
          <GridTable
            FilterData={filters}
            handlePagination={handlePagination}
            isGrid={gridToggle}
            SetGridToggle={SetGridToggle}
            type="store"
            value={value}
            fetchAllData={fetchAllData}
            setSelectedData={setSelectedData}
            setToggleUsersDetails={setToggleUsersDetails}
          />

          {toggleUsersDetails && (
            <StoreModal
              itemData={selectedData}
              setToggleUsersDetails={setToggleUsersDetails}
              toggleUsersDetails={toggleUsersDetails}
              fetchAllData={fetchAllData}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Store;